import { OrderType } from "@prisma/client";

import { enumTermToText } from "~/utils/strings";

export const DirectShipOrderTypes: OrderType[] = [OrderType.DIRECT_SHIP, OrderType.BLIND_SHIP];

export const isDirectShip = (type: OrderType | null): boolean => !!type && DirectShipOrderTypes.includes(type);

export const orderTypeDisplayMap = new Map<OrderType, string>();
Object.keys(OrderType).forEach(v =>
  // Object.keys on a string enum yields its members; TS types keys as string.
  orderTypeDisplayMap.set(v as OrderType, v === OrderType.BLIND_SHIP ? "Direct Ship: Supplier-Blind" : enumTermToText(v)),
);

export function getOrderTypeDisplay(value: OrderType | null | undefined) {
  return value === null || value === undefined ? "" : orderTypeDisplayMap.get(value);
}
